(function () {
  function qs(sel) { return document.querySelector(sel); }
  function qsa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  var locked = false;
  var scrollY = 0;

  function menuGroup() {
    return qs('#menu.mobile-only .btn-group');
  }

  function isOpen() {
    var g = menuGroup();
    return g ? (g.classList.contains('open') || g.classList.contains('show')) : false;
  }

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = (-scrollY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    locked = true;
  }

  function unlockScroll() {
    var top = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    var y = top ? (Math.abs(parseInt(top, 10)) || 0) : 0;
    window.scrollTo(0, y);
    locked = false;
  }

  function removeBackdrop() {
    qsa('#menu.mobile-only .dropdown-backdrop, body > .dropdown-backdrop').forEach(function (el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function closeMenu() {
    var g = menuGroup();
    if (g) {
      g.classList.remove('open', 'show');
      var toggle = qs('#menu.mobile-only [data-toggle="dropdown"]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
    removeBackdrop();
    if (locked) unlockScroll();
  }

  function sync() {
    if (isOpen() && !locked) lockScroll();
    if (!isOpen() && locked) unlockScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Close button
    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('#menu.mobile-only .button-close');
      if (!closeBtn) return;

      e.preventDefault();
      e.stopPropagation();
      closeMenu();
    });

    // Keep scroll lock in sync with menu open/close
    var menu = qs('#menu.mobile-only');
    if (menu) {
      new MutationObserver(function () { sync(); })
        .observe(menu, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-expanded'] });
    }

    // Fallback sync
    document.addEventListener('click', function () { setTimeout(sync, 0); });
    window.addEventListener('resize', sync);

    sync();
  });
})();
